/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
import { toInlineDataPart, toStoredDataPart } from "../common.js";
export { InMemoryBlobStore };
class InMemoryBlobStore {
    handles = new Map();
    #inflator;
    #deflator;
    constructor() {
        this.#inflator = {
            transform: async (_, part) => {
                if ("storedData" in part) {
                    return toInlineDataPart(part);
                }
                return part;
            },
        };
        this.#deflator = {
            transform: async (path, part) => {
                if ("inlineData" in part) {
                    const stored = await toStoredDataPart(part);
                    this.#registerHandle(path, stored.storedData.handle);
                    return stored;
                }
                return part;
            },
        };
    }
    #registerHandle(path, handle) {
        let pathHandles = this.handles.get(path);
        if (!pathHandles) {
            pathHandles = [];
            this.handles.set(path, pathHandles);
        }
        pathHandles.push(handle);
    }
    #deleteHandlesForPath(path) {
        const pathHandles = this.handles.get(path);
        if (pathHandles) {
            pathHandles.forEach((handle) => URL.revokeObjectURL(handle));
        }
        this.handles.delete(path);
    }
    async delete() {
        // blobs are scoped to the session, so we don't ever delete
        // anything.
    }
    inflator() {
        return this.#inflator;
    }
    deflator() {
        return this.#deflator;
    }
    async copy() {
        // a no op, there's nothing here to do.
    }
    async move() {
        // a no op, there's nothing here to do.
    }
    async close() {
        [...this.handles.keys()].forEach((path) => {
            this.#deleteHandlesForPath(path);
        });
    }
}
//# sourceMappingURL=in-memory-blob-store.js.map